import React from "react";
import { Row, Col } from "react-bootstrap";
import FormShimmer from "./FormShimmer ";

const DetailsShimmer = ({
  className = "",
  layout = [],
  shimmerActions = false,
}) => {
  return (
    <Row>
      {layout.map((card, cardIndex) => (
        <Col key={cardIndex} lg={card.col} className="mb-3">
          <div className={`common_card h-100 ${className}`}>
            {card.blocks.map((block, blockIndex) => (
              <div key={blockIndex} className={`mb-3 shimmer_wrapper ${card.type}`}>
                <FormShimmer
                  rows={block.rows}
                  cols={block.cols}
                  shimmerActions={shimmerActions}
                />
              </div>
            ))}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default DetailsShimmer;
